import * as actionTypes from './action-types';
import { API_REQUEST } from '../../../../store/sagas/api';
import { getGiftCardCheckoutInformation } from '../../../../backend-api';

export const loadGiftCardCheckoutInformation = ({ currency = null } = {}) => ({
  type: API_REQUEST,
  types: [
    actionTypes.LOAD_GIFT_CARD_CHECKOUT,
    actionTypes.LOAD_GIFT_CARD_CHECKOUT_SUCCESS,
    actionTypes.LOAD_GIFT_CARD_CHECKOUT_FAILED,
  ],
  call: () => getGiftCardCheckoutInformation({ currency }),
});
